module.exports = __webpack_public_path__ + "img/tips_white.f62714fa.svg";